<template>
  <div>
    <c-page-header/>
    <!--    <login></login>-->

    <c-page-footer/>
  </div>
</template>

<script>
import Login from "@/views/Login";
import CPageHeader from "@/views/component/C-PageHeader";
import CPageFooter from "@/views/component/C-PageFooter";

export default {
  name: "Layout",
  components: {
    Login,
    CPageHeader,
    CPageFooter,
  },
  data() {
    return {};
  },
  activated() {
  },
  mounted() {
    this.checkUserInfo()
  },
  methods: {
    checkUserInfo() {
      this.$router.push('/index')

      // let token = sessionStorage.getItem('token')
      // let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      // this.$store.state.token = token
      // this.$store.state.userInfo = userInfo
      // console.log('登录状态-->', !!(token && userInfo))
      // if (!!(token && userInfo)) {
      //   this.$router.push('/index')
      // } else {
      //   this.$router.push('/login')
      // }
    },
  }
}
</script>

<style scoped lang="less">
@import "~@public/color.less";

.title {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
}

.ant-layout-header {
  background: @primary-color;
  color: #fff;
  height: 7vh;
  line-height: 7vh;
}

.ant-layout-footer {
  background: @primary-color;
  color: #fff;
  height: 10vh;
  line-height: 7vh;
}

.ant-layout-sider {
  width: 100%;
  height: 83vh;
  background: #fff;
}

.ant-layout-content {
  box-shadow: inset 0 0 5px fade(@primary-color, 20%);
  padding: 12px;
  background: #fff;
  min-height: 120px;
  height: 83vh;
  overflow: auto;
}

/*滚动条整体样式*/
.ant-layout-content::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  margin-right: 10px;
  opacity: 0.2;
}

/*滚动条里面小方块(滑块 )*/
.ant-layout-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}

/*滚动条里面轨道(背景)*/
.ant-layout-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px @primary-color;
  border-radius: 10px;
  background: fade(@primary-color, 20%);
  opacity: 0.2;
}
</style>
